import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/pc/auth/login',
    method: 'post',
    data
  })
}

export function webUserLogin(data) {
  return request({
    url: '/pc/auth/webUserLogin',
    method: 'post',
    data
  })
}
